import { createContext } from 'react';
import { IMiniAppContextInterface } from '../../interfaces'

export default createContext<IMiniAppContextInterface>({ renderRoot: null });
